<template>
  <div class="logincon" @click="handleClose">
    <!--    合格投资者认定-->
    <div class="info-con eligible" @click="notClose">

      <div class="closebutton" @click="handleClose">关闭</div>
      <div class="reg-title">合格投资者认定</div>
      <div class="text">
        <p>东航金融谨遵 《私募投资基金募集行为管理办法》 和《私募投资基金监督管理暂行规定》 之规定，注册认证后的合格投资者才能访问蓝海密剑-私募基金公开赛排名。</p>
        <p>阁下如有意进行私募投资基金投资，请承诺符合监管机构规定的合格投资者的条件。即:</p>
        <p>(一)具备相应风险识别能力和风险承担能力。个人投资于单只私募基金的金额不低于100万且满足:金融资产不低于300万元,或者最近三年个人年均收入不低于50万元。</p>
        <p>(二)符合证券投资监管机构关于私募基金合格投资者认定的标准。其中，金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品信托计划、保险产品、期货权益等。</p>
        <p>请阁下确认自身具备合格投资者条件，方可获得东航金融私募投资基金投资理财服务。如果不具备合格投资者条件，请自行退出。</p></div>
      <div class="buttons">
        <div class="gray" @click="handleClose">取消</div>
        <div class="light" @click="goreg">已阅读并接受</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      goreg() {
        this.$emit("goreg")
      },
      handleClose() {
        this.$emit("closeaffirm")
      },
      notClose(event) {
        event.stopPropagation()
      }
    }
  }
</script>
<style scoped>
  .logincon {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .reg-title {
    display: inline-block;
    text-align: center;
    height: 68px;
    line-height: 68px;
    color: #fff;
    font-size: 30px;
    padding: 0 20px;
    font-family: MicrosoftYaHei-Bold;
    text-shadow: 2px 2px 20px #0ff;
    letter-spacing: 6px;
  }
  .info-con {

    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  .eligible {
    background-image: url("../assets/hgtzzrd.png");
    width: 840px;
    height: 550px;
  }

  .text {
    font-size: 16px;
    margin: 30px 70px;
    text-align: left;
  }

  .text p {
    text-indent: 32px;
    line-height: 28px;
    letter-spacing: 1px;
    color: #232323;
  }

  .buttons div {
    display: inline-block;
    width: 240px;
    margin: 0 25px;
    color: #fff;
    border-radius: 6px;
    height: 50px;
    line-height: 50px;
  }

  .gray {
    background: #b5b5b5;
  }

  .light {
    background: #00bcbc;
  }
  .closebutton {
    position: absolute;
    color: #fff;
    right: 20px;
    top: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/affirm.vue